import { useEffect, useState } from 'react';
import _isNil from 'lodash/isNil';
import { tryGetCollections } from '../../../api/design';

export const useGetCollections = (host, dataReady) => {
  const [collections, setCollections] = useState([]);
  const [collectionsDataReady, setCollectionsDataReady] = useState(false);

  const fetchData = async () => {

    try {
      const response = await tryGetCollections(host);

      setCollections(response || []);
      setCollectionsDataReady(!_isNil(response));
    } catch (error) {
      console.error('Error fetching collections:', error);
      setCollections([]);
      setCollectionsDataReady(true);
    }
  };

  useEffect(() => {

    if (!_isNil(host) && !_isNil(dataReady) && !dataReady) {
      fetchData();
    }
  }, [host, dataReady]);

  return {
    collections,
    collectionsDataReady,
  };
};
